/**
 * config.ts — Constantes globais do cliente.
 *
 * Paleta de cores dos jogadores (slot 0 = neutro, 1-8 = jogadores).
 * Usamos dois formatos: 0xHEX pro Pixi e #string pra CSS/HTML.
 */

export const CORES_HEX = [
  0x000000, // 0 — nunca usado (donoId 0 = neutro, vira COR_NEUTRA_HEX)
  0x3b82f6, // 1 azul
  0x10b981, // 2 verde
  0xf59e0b, // 3 ambar
  0xef4444, // 4 vermelho
  0xa855f7, // 5 roxo
  0x06b6d4, // 6 ciano
  0xf97316, // 7 laranja
  0xec4899, // 8 rosa
] as const;

export const COR_NEUTRA_HEX = 0x64748b;

export const CORES_CSS = [
  '#64748b', // 0 neutro
  '#3b82f6',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#a855f7',
  '#06b6d4',
  '#f97316',
  '#ec4899',
] as const;

export function corPlaneta(donoId: number): number {
  if (donoId === 0 || !donoId) return COR_NEUTRA_HEX;
  return CORES_HEX[donoId] ?? COR_NEUTRA_HEX;
}

export function corHex(donoId: number): string {
  return CORES_CSS[donoId] ?? CORES_CSS[0];
}

// Planetas especiais (Fase 5.2)
export const CORES_ESPECIAIS: Record<string, number> = {
  industrial: 0xfbbf24, // dourado
  fortaleza:  0x60a5fa, // azul-celeste
  trampolim:  0x84cc16, // verde-lima
};

export const EMOJIS_ESPECIAIS: Record<string, string> = {
  industrial: '⚙', // engrenagem
  fortaleza:  '⛨', // escudo
  trampolim:  '➤', // seta
};

export const NOMES_ESPECIAIS: Record<string, string> = {
  industrial: 'INDUSTRIAL +50% prod',
  fortaleza:  'FORTALEZA HP 2x',
  trampolim:  'TRAMPOLIM +30% vel',
};
